
































































































































import { Component, Vue } from "vue-property-decorator";
import Form77Service from "@/services/Form77";
import { appModule } from "@/store/modules/app";

@Component
export default class TimPengujiKesehatanPage extends Vue {
  items: any[] = [];
  loading = false;
  dialog = false;
  saving = false;
  cariTerm = "";
  dokterItems: any[] = [];

  headers = [
    { text: "Nama Tim", value: "nama_tim" },
    { text: "No. SK", value: "sk_nomor" },
    { text: "Anggota", value: "anggota_count" },
    { text: "Status", value: "aktif" },
    { text: "Aksi", value: "aksi", sortable: false, align: "right" }
  ];

  peranOptions = [
    { text: "Ketua", value: "ketua" },
    { text: "Anggota", value: "anggota" },
    { text: "NGT", value: "ngt" }
  ];

  form: any = this.emptyForm();

  emptyForm() {
    return {
      id: null,
      nama_tim: null,
      sk_nomor: null,
      sk_tanggal: null,
      sk_berlaku_sampai: null,
      aktif: true,
      urutan: 0,
      anggota: []
    };
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const resp = await Form77Service.listTim({ per_page: 100 });
      const payload = resp && resp.data ? resp.data : resp;
      this.items = payload && payload.data ? payload.data : [];
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.form = this.emptyForm();
    this.dokterItems = [];
    this.dialog = true;
  }

  async openEdit(item: any) {
    const resp = await Form77Service.findTim(item.id);
    const tim = resp && resp.data ? resp.data : item;
    this.form = {
      id: tim.id,
      nama_tim: tim.nama_tim,
      sk_nomor: tim.sk_nomor,
      sk_tanggal: tim.sk_tanggal,
      sk_berlaku_sampai: tim.sk_berlaku_sampai,
      aktif: !!tim.aktif,
      urutan: tim.urutan || 0,
      anggota: (tim.anggota || []).map((a: any) => ({
        user_id: a.user_id,
        peran: a.peran,
        bidang: a.bidang,
        nama: a.nama,
        nip: a.nip,
        str: a.str,
        sip: a.sip,
        urutan_pdf: a.urutan_pdf
      }))
    };
    // pastikan anggota tampil di autocomplete
    this.dokterItems = this.form.anggota
      .filter((a: any) => a.user_id)
      .map((a: any) => ({ user_id: a.user_id, nama: a.nama }));
    this.dialog = true;
  }

  async cariDokter() {
    if (!this.cariTerm) return;
    const resp = await Form77Service.cariDokter(this.cariTerm);
    const list = resp && resp.data ? resp.data : [];
    // gabung agar pilihan lama tetap ada
    const map: any = {};
    [...this.dokterItems, ...list].forEach((d: any) => {
      map[d.user_id] = d;
    });
    this.dokterItems = Object.keys(map).map(k => map[k]);
  }

  onPilihDokter(a: any) {
    const found = this.dokterItems.find((d: any) => d.user_id === a.user_id);
    if (found && !a.nama) {
      a.nama = found.nama;
    }
    if (found) {
      a.nama = found.nama;
    }
  }

  tambahAnggota() {
    this.form.anggota.push({
      user_id: null,
      peran: "anggota",
      bidang: null,
      nama: null,
      nip: null,
      str: null,
      sip: null,
      urutan_pdf: this.form.anggota.length
    });
  }

  hapusAnggota(i: number) {
    this.form.anggota.splice(i, 1);
  }

  async simpan() {
    if (!this.form.nama_tim) {
      appModule.sendErrorAlert("Nama Tim wajib diisi");
      return;
    }
    if (!this.form.anggota.length) {
      appModule.sendErrorAlert("Tambahkan minimal satu anggota");
      return;
    }
    const ketua = this.form.anggota.filter((a: any) => a.peran === "ketua");
    if (ketua.length !== 1) {
      appModule.sendErrorAlert("Tim wajib memiliki tepat satu Ketua");
      return;
    }
    if (this.form.anggota.some((a: any) => !a.user_id)) {
      appModule.sendErrorAlert("Setiap baris anggota wajib memilih dokter");
      return;
    }

    this.saving = true;
    try {
      if (this.form.id) {
        await Form77Service.updateTim(this.form.id, this.form);
      } else {
        await Form77Service.createTim(this.form);
      }
      appModule.NoticeDelay("Tim Penguji berhasil disimpan");
      this.dialog = false;
      this.load();
    } finally {
      this.saving = false;
    }
  }

  async hapus(item: any) {
    if (!window.confirm(`Hapus tim "${item.nama_tim}"?`)) return;
    await Form77Service.destroyTim(item.id);
    appModule.NoticeDelay("Tim Penguji dihapus");
    this.load();
  }
}
